import type { SVGProps } from 'react';

// Original line icon set (24 × 24, 2 px strokes, round caps), drawn for MemoNest.
const P: Record<string, string> = {
  checklist: 'M4 6.5l1.6 1.6L8.5 5M4 13.5l1.6 1.6L8.5 12M12 7h8M12 14h8M4 19.5h4.5M12 19.5h8',
  text: 'M3 18L8 6l5 12M4.8 14h6.4M15 18c-.1-1.5 1-2.8 3-2.8h2.6M20.5 18v-4.6c0-1.6-1.1-2.6-2.8-2.6-1.1 0-2 .4-2.6 1.1',
  image: 'M4 6.5A2.5 2.5 0 016.5 4h9A2.5 2.5 0 0118 6.5V11M4 16l4.2-4.2a1.5 1.5 0 012.1 0L14 15.5M4 6.5v10A2.5 2.5 0 006.5 19H12M13.5 9.2a1.4 1.4 0 11-2.8 0 1.4 1.4 0 012.8 0M18 14v6M15 17h6',
  trash: 'M4.5 7h15M10 7V5.2c0-.7.5-1.2 1.2-1.2h1.6c.7 0 1.2.5 1.2 1.2V7M6.5 7l.8 11.3c.1 1 .9 1.7 1.9 1.7h5.6c1 0 1.8-.7 1.9-1.7L17.5 7M10.2 11v5.5M13.8 11v5.5',
  history: 'M4 12a8 8 0 102.4-5.7M4 4.5v3.8h3.8M12 8v4.3l3 1.9',
  plus: 'M12 5v14M5 12h14',
  more: 'M6 12h.01M12 12h.01M18 12h.01',
  close: 'M6 6l12 12M18 6L6 18',
  undo: 'M9 7L5 11l4 4M5 11h9.5a4.5 4.5 0 010 9H11',
  redo: 'M15 7l4 4-4 4M19 11H9.5a4.5 4.5 0 000 9H13',
  brush: 'M14.5 4.5l5 5-7.8 7.8c-1.1 1.1-2.6 1.4-3.9.9L4 20l1.8-3.8c-.5-1.3-.2-2.8.9-3.9l7.8-7.8zM12 7l5 5',
  back: 'M15 5l-7 7 7 7',
  forward: 'M9 5l7 7-7 7',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4',
  pin: 'M9 4h6l-1 5 3 3v2H7v-2l3-3-1-5zM12 14v6',
  star: 'M12 3.8l2.5 5.1 5.6.8-4 3.9 1 5.6-5.1-2.7-5 2.7.9-5.6-4-3.9 5.6-.8L12 3.8z',
  archive: 'M4 5h16v4H4zM5.5 9v9.5c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5V9M10 13h4',
  copy: 'M9 9h10v11H9zM15 9V5.5c0-.8-.7-1.5-1.5-1.5h-8C4.7 4 4 4.7 4 5.5v8c0 .8.7 1.5 1.5 1.5H9',
  calendar: 'M5 6h14v14H5zM5 10h14M9 4v4M15 4v4',
  bell: 'M6 16V11a6 6 0 1112 0v5l1.5 2h-15L6 16zM10 20.5a2 2 0 004 0',
  phone: 'M8 3h8a2 2 0 012 2v14a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2zM10.5 18h3',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 13.5l1.4 1.1-1.6 2.8-1.7-.6a7 7 0 01-1.9 1.1l-.3 1.8h-3.2l-.3-1.8a7 7 0 01-1.9-1.1l-1.7.6-1.6-2.8 1.4-1.1a7 7 0 010-2.2L5.6 10.4 7.2 7.6l1.7.6a7 7 0 011.9-1.1l.3-1.8h3.2l.3 1.8a7 7 0 011.9 1.1l1.7-.6 1.6 2.8-1.4 1.1a7 7 0 010 2.2z',
  download: 'M12 4v11M7.5 10.5L12 15l4.5-4.5M5 19h14',
  upload: 'M12 15V4M7.5 8.5L12 4l4.5 4.5M5 19h14',
  share: 'M12 15V4M8 7.5L12 3.5l4 4M6 11v8.5h12V11',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 15a3 3 0 100-6 3 3 0 000 6z',
  'layer-up': 'M12 4l8 4-8 4-8-4 8-4zM4 12l8 4 8-4M12 20v-4',
  'layer-down': 'M12 20l8-4-8-4-8 4 8 4zM4 12l8-4 8 4M12 4v4',
  lock: 'M7 11V8a5 5 0 0110 0v3M5.5 11h13v9h-13zM12 14.5v2',
  unlock: 'M7 11V8a5 5 0 019.6-1.9M5.5 11h13v9h-13zM12 14.5v2',
  rotate: 'M19 12a7 7 0 11-2.1-5M19 4v4h-4',
  crop: 'M7 3v14h14M3 7h14v14',
  wand: 'M5 19L15.5 8.5M14 4v2M19 9h2M17.5 5.5L19 4M18 13l1.5 1.5M10 4.5l1 1.5',
  grip: 'M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01',
  check: 'M5 12.5l4.2 4.2L19 7',
  alarm: 'M12 21a8 8 0 100-16 8 8 0 000 16zM12 9v4l2.5 1.5M5 3.5L2.5 6M19 3.5L21.5 6',
  sparkles: 'M12 4l1.6 4.4L18 10l-4.4 1.6L12 16l-1.6-4.4L6 10l4.4-1.6L12 4zM18.5 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8.8-2z',
  info: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 11v6M12 7.5h.01',
  heading: 'M6 5v14M18 5v14M6 12h12',
  bold: 'M7 5h6a3.5 3.5 0 010 7H7zM7 12h7a3.5 3.5 0 010 7H7z',
  italic: 'M10 5h8M6 19h8M14 5l-4 14',
  underline: 'M7 4v7a5 5 0 0010 0V4M5 20h14',
  'align-left': 'M4 6h16M4 10h10M4 14h16M4 18h10',
  'align-center': 'M4 6h16M7 10h10M4 14h16M7 18h10',
  'align-right': 'M4 6h16M10 10h10M4 14h16M10 18h10',
  eraser: 'M8.5 19l-4-4a2 2 0 010-2.8l8.8-8.8a2 2 0 012.8 0l3.7 3.7a2 2 0 010 2.8L12 19H8.5zM9.5 9.5l5 5M12 19h8',
  marker: 'M15 4l5 5-9 9H6v-5l9-9zM13 6l5 5M6 18l-2 2',
  pen: 'M16.5 3.5l4 4L8 20H4v-4L16.5 3.5z',
  highlighter: 'M9 15l-4 4h6l2-2M9 15l6-10 4 4-6 10-4-4z',
  crayon: 'M7 17l10-10 2 2-10 10H7v-2zM15 5l1.5-1.5a1.4 1.4 0 012 2L17 7',
  palette: 'M12 21a9 9 0 110-18c5 0 9 3.6 9 8 0 2.8-2.2 4.5-4.5 4.5h-1.8c-1 0-1.7.8-1.7 1.7 0 .5.2.9.5 1.2.3.4.5.8.5 1.2 0 .8-.6 1.4-2 1.4zM7.5 11.5h.01M10 7.5h.01M14.5 7.5h.01M17 11h.01',
  timeline: 'M5 4v16M5 7h9M5 12h13M5 17h7',
  fullscreen: 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5',
  flip: 'M12 3v18M8 7L3 12l5 5M16 7l5 5-5 5',
  tag: 'M3.5 12.5V4h8.5l8.5 8.5-8.5 8.5-8.5-8.5zM8 8h.01',
  focus: 'M12 12m-3 0a3 3 0 106 0 3 3 0 10-6 0M12 2v3M12 19v3M2 12h3M19 12h3',
  print: 'M7 9V3h10v6M7 17H4v-7h16v7h-3M7 14h10v7H7z',
  wallpaper: 'M4 5h16v14H4zM4 15l5-4 4 3 3-2 4 3',
  compact: 'M12 3v6M9 6.5L12 9l3-2.5M4 12h16M12 21v-6M9 17.5l3-2.5 3 2.5',
  stack: 'M7 8h11a2 2 0 012 2v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8a2 2 0 012-2zM8 4h9',
  copyinfo: 'M9 9h10v11H9zM15 9V5.5c0-.8-.7-1.5-1.5-1.5h-8C4.7 4 4 4.7 4 5.5v8c0 .8.7 1.5 1.5 1.5H9',
  help: 'M12 21a9 9 0 100-18 9 9 0 000 18zM9.5 9.5a2.5 2.5 0 114 2c-.9.6-1.5 1.1-1.5 2.2M12 17h.01',
  replay: 'M4 12a8 8 0 108-8 8 8 0 00-6 2.7M4 4v4h4',
  doc: 'M7 3h7l4 4v14H7zM14 3v4h4M10 12h5M10 16h5',
  template: 'M4 8h16v8H4z',
  emptynote: 'M5 7V5h2M17 5h2v2M19 17v2h-2M7 19H5v-2M10 5h4M10 19h4M5 10v4M19 10v4',
  delline: 'M4 7a2 2 0 104 0 2 2 0 10-4 0M11 7h9M4 12h16M4 17h16',
  logo: 'M5 7c2-2 4-1 3 1s-3 4-1 4 4-3 5-5M13 16c2-1 5-1 7 0',
};

export type IconName = keyof typeof P;

export function Icon({ name, size = 24, strokeWidth = 2, ...rest }: { name: IconName; size?: number; strokeWidth?: number } & SVGProps<SVGSVGElement>) {
  const fillIcon = name === 'more';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={fillIcon ? 3.2 : strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={P[name]} />
    </svg>
  );
}

/** The editor's pen icon shows the current ink colour on its tip, as in the reference toolbar. */
export function PenIcon({ tip, size = 24 }: { tip: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M16.5 3.5l4 4L9.8 18.2l-4-4L16.5 3.5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M5.8 14.2l4 4L4 20l1.8-5.8z" fill={tip} stroke={tip} strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}
